(() => {
  'use strict';
  function init(root = document) {
    root.querySelectorAll('.ec2-index:not([data-ec2-ready])').forEach(section => {
      section.dataset.ec2Ready = 'true';
      const rail = section.querySelector('[data-ec2-rail]');
      if (!rail) return;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const move = direction => rail.scrollBy({left: direction * rail.clientWidth * 0.9, behavior: reduced.matches ? 'instant' : 'smooth'});
      section.querySelector('[data-ec2-prev]')?.addEventListener('click', () => move(-1));
      section.querySelector('[data-ec2-next]')?.addEventListener('click', () => move(1));
      rail.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
    });
    root.querySelectorAll('.ec2-hero:not([data-ec2-ready])').forEach(hero => {
      hero.dataset.ec2Ready = 'true';
      const button = hero.querySelector('.ec2-motion');
      const video = hero.querySelector('video');
      const media = window.matchMedia('(prefers-reduced-motion: reduce)');
      const apply = paused => {
        hero.classList.toggle('is-paused', paused);
        button?.setAttribute('aria-pressed', String(paused));
        if (button) button.querySelector('span').textContent = paused ? '▶' : 'Ⅱ';
        if (video) {
          if (paused) video.pause(); else video.play().catch(() => {});
        }
      };
      if (media.matches) apply(true);
      button?.addEventListener('click', () => apply(!hero.classList.contains('is-paused')));
      media.addEventListener('change', event => { if (event.matches) apply(true); });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
